import React from 'react';

import {
  useCheckDeletionVerifierStaffQuery,
  useDeleteVerifierStaffMutation,
  VerifierStaffListDocument,
} from 'src/api';
import { useNotification } from 'src/hooks/app';
import { DeleteConfirmationModal } from 'src/modals/common';
import { ModalV2Props } from 'src/types/modalV2';

type DeleteVerifierStaffConfirmationModalProps = {
  verifierStaffId: string;
};

export const DeleteVerifierStaffConfirmationModal: React.FC<
  ModalV2Props<DeleteVerifierStaffConfirmationModalProps>
> = ({ id, verifierStaffId }) => {
  const { createApolloContext } = useNotification();

  const { data, loading } = useCheckDeletionVerifierStaffQuery({
    variables: { verifierStaffId },
    fetchPolicy: 'network-only',
  });

  const [deleteVerifierStaff, { loading: deleteLoading }] = useDeleteVerifierStaffMutation({
    refetchQueries: [VerifierStaffListDocument],
    context: createApolloContext({ successMessage: 'Successfully deleted' }),
  });

  const handleConfirm = React.useCallback(
    () => deleteVerifierStaff({ variables: { verifierStaffId } }),
    [deleteVerifierStaff, verifierStaffId],
  );

  return (
    <DeleteConfirmationModal
      id={id}
      entityName="Verifier staff"
      description="You want to delete this staff member?"
      check={data?.checkDeletionVerifierStaff}
      loading={loading}
      deleteLoading={deleteLoading}
      onConfirm={handleConfirm}
    />
  );
};
